export enum PosthogFeatureFlag {
  TASKS_SYSTEM = 'tasks_system',
}
